<template>
  <div>
    <div @click="paymentDoneDialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-dialog
      v-model="paymentDoneDialog"
      scrollable
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="closePaymentDoneDialog(false)"
    >
      <v-card>
        <v-toolbar dark color="primary" max-height="60">
          <h3>{{ label }}</h3>
          <v-btn
            v-if="payment_loading == true"
            class="text-center"
            text
            fab
            color="white"
            :loading="payment_loading"
          ></v-btn>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closePaymentDoneDialog(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <payment-done-edit
            :singlePage="true"
            @closeDialog="closePaymentDoneDialog"
            :vendor_id="vendor_id"
            :entity_id="entity_id"
            :paymentEdit_id="paymentEdit_id"
            :date="date"
            :fare="fare"
            :trip="trip"
            :trip_id="trip ? trip._id : null"
            :expense="expense"
            :expense_id="expense ? expense._id : null"
            :hideBills="hideBills"
            :hideTrips="hideTrips"
            @setLoading="setLoading"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import PaymentDoneEdit from "@/views/paymentdone/PaymentDoneEdit.vue";

@Component({
  name: "PaymentDoneCreate",
  components: {
    PaymentDoneEdit,
  },
  props: {
    label: {
      default: "Supplier Payment",
    },
    paymentEdit_id: {
      default: null,
    },
    entity_id: {
      default: null,
    },
    vendor_id: {
      default: null,
    },
    vendorEntity_id: {
      default: null,
    },
    date: {
      default: null,
    },
    fare: {
      default: null,
    },
    trip: {
      default: null,
    },
    expense: {
      default: null,
    },
    btn: {
      default: false,
    },
    hideTrips: {
      default: null,
    },
    hideBills: {
      default: null,
    },
  },
})
export default class PaymentDoneCreate extends Vue {
  paymentDoneDialog = false;
  payment_loading = false;

  closePaymentDoneDialog(reload) {
    this.paymentDoneDialog = false;
    this.$emit("reload", reload);
  }

  setLoading(loading) {
    this.payment_loading = loading;
  }
}
</script>
